<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12">
        <div class="card">

          <v-app>
            <v-container fluid>
              <v-card elevation="2" outlined>
                <v-card-title>
                  <!--                                    v-if="$can('transaction_create')"-->
                  <v-btn to="/content/create" rounded color="#308BB0" class="text-white" v-status="'content_create'">
                    <v-icon>mdi-plus</v-icon>
                    افزودن محتوا
                  </v-btn>
                  <v-spacer/>
                  مدریت محتوا
                  <v-spacer/>
                  <v-btn :loading="loading" @click="this.fetchIndexData" color="primary" rounded class="text-white">
                    <v-icon>mdi-refresh</v-icon>
                    به روزرسانی
                  </v-btn>

                </v-card-title>
                <v-divider/>
                    <div class="row">
                      <div class="col-md-12 p-5">

                        <data-table
                            :data="data"
                            :columns="columns"
                            :debounce-delay="5000"
                            :translate="translate"
                            :per-page="[10, 25, 50, 100, 400]"
                            @on-table-props-changed="reloadTable"
                        >
                        </data-table>
                      </div>
                    </div>

              </v-card>
            </v-container>
          </v-app>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import Btn from "@/view/pages/categories/Btn";
import {SET_BREADCRUMB} from "@/core/services/store/breadcrumbs.module";

export default {
  data() {
    return {
      url: 'content',
      columns: [
        {
          label: 'شناسه',
          name: 'id',
          orderable: true,
          colStyle: 'width: 100px;'
        },
        {
          label: 'نام',
          name: 'title',
          orderable: true,
          transform: (val) => {
            return val.data.title.length > 10 ? val.data.title.substring(0, 10) + ' ...': val.data.title;
          }
        },
        {
          label: 'لینک',
          name: 'link',
          transform: (value, data) => {
            return value.data.link == null ? '<p class="text-danger">ندارد</p>' : value.data.link;
          },
          orderable: true,
        },
        {
          label: 'نوع سرویس',
          name: 'service',
          transform: (val) => {
            console.log(val.data)
            return this.$options.filters.serviceType(val.data.service.nameLand);
          }
        },
        {
          label: 'تاریخ ویرایش',
          name: 'updated_at',
          transform: (val) => {
            return this.$options.filters.longDate(val.data.updated_at)
          }
        },
        {
          label: 'عملیات',
          name: 'actions',
          type: 'html',
          component: Btn,
          handler: this.action,
          event:'action',
          meta: {
            permission_prefix: 'content_',
          }

        },
      ],
      data: {},
      translate: {
        nextButton: 'بعدی',
        previousButton: 'قبلی',
        rowsPerPageText: 'تعداد در صفحه',
        noDataText: 'داده ای برای نمایش وجود ندارد',
        placeholderSearch: 'جستجو',
      },
      tableProps: {
        search: '',
        length: 10,
        column: 'id',
        dir: 'desc',
      },
      query: {sort: 'id', order: 'desc', limit: 25, s: ''},
      xprops: {
        module: 'ContentIndex',
        route: 'content',
        content_prefix: 'content_',
        fetchIndexData: 'fetchIndexData',

      }
    }
  },
  created() {
    this.getData(this.url)
    this.$store.dispatch(SET_BREADCRUMB, [{title: this.$route.meta.title}])
  },
  beforeDestroy() {
    this.resetState()
  },
  computed: {
    ...mapGetters(["layoutConfig"]),
    ...mapGetters('ContentIndex', ['contents', 'total', 'loading']),

    config() {
      return this.layoutConfig();
    }
  },
  // watch: {
  //   query: {
  //     handler(query) {
  //       // this.setQuery(query)
  //       this.fetchIndexData()
  //     },
  //     deep: true
  //   }
  // },
  methods: {
    getData(url = this.url, options = this.tableProps) {
      this.requestApiGet(this.url, options).then(response => {
        this.data = response.data
      })
    },

    reloadTable(tableProps) {
      this.getData(this.url, tableProps)
    },

    action(data, type) {
      this[type](data)

    },
    delete(data) {
      this.$swal({
        text: 'آیا از حذف این  محتوا اطمینان دارید؟',
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'بله',
        cancelButtonText: 'خیر',
        reverseButtons: true,
        confirmButtonClass: 'btn btn-danger',
        cancelButtonClass: 'btn btn-secondary',
        buttonsStyling: false
      }).then(result => {
        if (result.isConfirmed) {
          this.requestApiDelete(`content/${data.id}`).then(response => {
            this.reloadTable(this.tableProps)
            this.$toast.success('دسته بندی با موفقیت حذف شد')
          })
        }

      })
    },

    edit(data){
      this.$router.push({name:'content.edit',params:{id:data.id}})
    },
    ...mapActions('ContentIndex', [
      'fetchIndexData',
      'setQuery',
      'resetState'
    ])
  }
}
</script>
